/* eslint-disable @typescript-eslint/no-unused-vars */

export const API_CASINO_BASE = '/crea/casino/api';
export const API_CASINO_BASE_DATA = `${API_CASINO_BASE}/data`;

export const API_CASINO_SETTINGS_GAMES = `${API_CASINO_BASE}/settings/games`;
export const API_CASINO_SETTINGS_GAMES_UPDATE = `${API_CASINO_SETTINGS_GAMES}/update`;

export const API_CASINO_SETTINGS_LOGO = '/crea/casino/api/settings/logo';
export const API_CASINO_SETTINGS_LOGO_UPDATE = `${API_CASINO_SETTINGS_LOGO}/update`;

export const API_CASINO_SETTINGS_TEMPLATE = `${API_CASINO_BASE}/settings/template`;
export const API_CASINO_SETTINGS_TEMPLATE_UPDATE = `${API_CASINO_SETTINGS_TEMPLATE}/update`;

export const API_CASINO_GAME_CREATORS_SEO = `${API_CASINO_BASE}/settings/seo`;

export const API_CASINO_SETTINGS_GAMES_SEO = `${API_CASINO_BASE}/settings/seo/games`;
export const API_CASINO_SETTINGS_GAMES_SEO_SHOW = `${API_CASINO_SETTINGS_GAMES_SEO}/template/:id`;
export const API_CASINO_SETTINGS_GAMES_SEO_UPDATE = `${API_CASINO_SETTINGS_GAMES_SEO}/update`;
export const API_CASINO_SETTINGS_GAMES_SEO_DELETE = `${API_CASINO_GAME_CREATORS_SEO}/delete/:id`;
export const API_CASINO_SETTINGS_GAMES_SEO_ASSIGN_TEMPLATES = `${API_CASINO_GAME_CREATORS_SEO}/assignTemplatesToGames/:gameCreatorId`;
export const API_CASINO_SETTINGS_GAMES_SEO_CREATE = `${API_CASINO_SETTINGS_GAMES_SEO}/create`;
export const API_CASINO_SETTINGS_GAMES_SEO_GET_TITLES_BY_GAME_CREATOR_ID = `${API_CASINO_SETTINGS_GAMES_SEO}/getSeoTitles/:gameCreatorId`;
export const API_CASINO_CHANGE_SEO_TAG_FOR_GAME = `${API_CASINO_SETTINGS_GAMES_SEO}/changeSeoTag`;

const API_CASINO_NEWS_WIDGET_BASE = `${API_CASINO_BASE}/news/games-widget`;
export const API_CASINO_NEWS_WIDGET_GAMES = `${API_CASINO_NEWS_WIDGET_BASE}`;
export const API_CASINO_NEWS_WIDGET_GAMES_ADD = `${API_CASINO_NEWS_WIDGET_BASE}`;
export const API_CASINO_NEWS_WIDGET_GAMES_DELETE = `${API_CASINO_NEWS_WIDGET_BASE}/:gameId`;

export const API_CASINO_GAME_TYPES = `${API_CASINO_BASE_DATA}/game-types`;

export const API_CASINO_GAME_CATEGORY_DATA = `${API_CASINO_BASE_DATA}/game-category/:id`;
export const API_CASINO_GAME_CATEGORIES = `${API_CASINO_BASE}/game-categories`;
export const API_CASINO_GAME_CATEGORY = `${API_CASINO_GAME_CATEGORIES}/:id`;
export const API_CASINO_GAME_CATEGORY_SORTED_GAMES = `${API_CASINO_GAME_CATEGORIES}/:id/sortedGames`;
export const API_CASINO_GAME_CATEGORIES_CREATE = `${API_CASINO_GAME_CATEGORIES}/create`;
export const API_CASINO_GAME_CATEGORIES_EDIT = `${API_CASINO_GAME_CATEGORIES}/:id/edit`;
export const API_CASINO_GAME_CATEGORIES_DELETE = `${API_CASINO_GAME_CATEGORIES}/:id/delete`;
export const API_CASINO_GAME_CATEGORIES_UPDATE_ORDER = `${API_CASINO_GAME_CATEGORIES}/updateOrder`;
export const API_CASINO_GAME_CATEGORIES_INSERT_GAME = `${API_CASINO_GAME_CATEGORIES}/insert/:id`;
export const API_CASINO_GAME_CATEGORIES_REMOVE_GAME = `${API_CASINO_GAME_CATEGORIES}/:categoryId/remove/:gameId`;

export const API_CASINO_GAME_CATEGORY_GAME_ORDER_UPDATE_ORDER = `${API_CASINO_BASE}/game-categories-game-order/updateOrder`;

export const API_CASINO_GAME_CATEGORY_BLOCK_UPLOAD_IMAGE = `${API_CASINO_BASE}/game-category-blocks/uploadImage`;

export const API_CASINO_DEPOSIT_BONUS_PAGES = `${API_CASINO_BASE}/deposit-bonus-pages`;
export const API_CASINO_DEPOSIT_BONUS_PAGES_DELETE = `${API_CASINO_DEPOSIT_BONUS_PAGES}/:id`;

export const API_CASINO_DEPOSIT_BONUSES = `${API_CASINO_BASE}/deposit-bonuses`;
export const API_CASINO_DEPOSIT_BONUSES_CREATE = `${API_CASINO_DEPOSIT_BONUSES}/create`;
export const API_CASINO_DEPOSIT_BONUSES_DELETE = `${API_CASINO_DEPOSIT_BONUSES}/:id/delete`;

export const API_CASINO_UPLOAD_PNG_IMAGE = `${API_CASINO_BASE}/upload/png`;
const API_CASINO_DASHBOARD = `${API_CASINO_BASE}/dashboard`;
export const API_CASINO_DASHBOARD_GGR = `${API_CASINO_DASHBOARD}/ggr`;
export const API_CASINO_DASHBOARD_GGR_MARGIN = `${API_CASINO_DASHBOARD}/ggr-margin`;
export const API_CASINO_DASHBOARD_GGR_LAST_WEEKS = `${API_CASINO_DASHBOARD}/ggr-last-weeks`;
export const API_CASINO_DASHBOARD_WAGERED_LAST_WEEKS = `${API_CASINO_DASHBOARD}/wagered-last-weeks`;
export const API_CASINO_DASHBOARD_DETAILED_BREAKDOWN = `${API_CASINO_DASHBOARD}/detailed-breakdown`;
export const API_CASINO_DASHBOARD_DETAILED_BREAKDOWN_SUMMARY = `${API_CASINO_DASHBOARD}/detailed-breakdown-summary`;

export const API_CASINO_TRANSACTIONS = `${API_CASINO_BASE}/transactions`;
export const API_CASINO_SESSIONS = `${API_CASINO_BASE}/sessions`;
export const API_CASINO_SESSION_BETS = `${API_CASINO_TRANSACTIONS}/bet/:sessionId`;
export const API_CASINO_TRANSACTIONS_FOR_USER = `${API_CASINO_TRANSACTIONS}/user`;
export const API_CASINO_DETAILED_BREAKDOWN_PER_USER = `${API_CASINO_TRANSACTIONS_FOR_USER}/detailed-breakdown`;
export const API_CASINO_DETAILED_BREAKDOWN_TOTALS_PER_USER = `${API_CASINO_TRANSACTIONS_FOR_USER}/detailed-breakdown-totals`;

export const API_CASINO_USER_BONUSES = `${API_CASINO_BASE}/casino-user-bonuses`;
export const API_CASINO_USER_BONUSES_FOR_USER = `${API_CASINO_USER_BONUSES}/user`;

export const API_CASINO_REPORTS = `${API_CASINO_BASE}/reports`;
export const API_CASINO_REPORT_BONUS_SUMMARY = `${API_CASINO_REPORTS}/bonus-summary`;

export const API_CASINO_AFFILIATES = `${API_CASINO_BASE}/affiliates`;
export const API_CASINO_AFFILIATES_SUMMARY = `${API_CASINO_AFFILIATES}/summary`;
